module.exports = __webpack_public_path__ + "img/08.d47d04f4.jpg";